import readRegularWoff from './fonts/read/Read-Regular_V1100.woff';
import readRegularEot from './fonts/read/Read-Regular_V1100.eot';
import readLightWoff from './fonts/read/Read-Light_V1100.woff';
import readLightEot from './fonts/read/Read-Light_V1100.eot';
import readBoldWoff from './fonts/read/Read-Bold_V1100.woff';
import readBoldEot from './fonts/read/Read-Bold_V1100.eot';
import daciaSpiritRegularWoff from './fonts/spirit/DaciaSpirit-Regular_V1000.woff';
import daciaSpiritRegularEot from './fonts/spirit/DaciaSpirit-Regular_V1000.eot';
import daciaSpiritLightWoff from './fonts/spirit/DaciaSpirit-Light_V1000.woff';
import daciaSpiritLightEot from './fonts/spirit/DaciaSpirit-Light_V1000.eot';
import daciaSpiritBoldWoff from './fonts/spirit/DaciaSpirit-Bold_V1000.woff';
import daciaSpiritBoldEot from './fonts/spirit/DaciaSpirit-Bold_V1000.eot';

import daciaSpiritNewWoff from './fonts/spirit/DaciaSpirit-BlackV1500Latin-Cyrillic.woff';
import daciaSpiritNewEot from './fonts/spirit/DaciaSpirit-BlackV1500Latin-Cyrillic.eot';

import daciaBlockVariableWoff from './fonts/dacia-block/DaciaBlock-Variable.woff';

import readBeta2RegularWoff from './fonts/read-beta-2/medium-v3100-Latin-Cyrillic.woff2';
import readBeta2LightWoff from './fonts/read-beta-2/light-v3100-Latin-Cyrillic.woff2';

const globalStyles = () => ({
  '@global': {
    '*': {
      boxSizing: 'border-box'
    },
    'html, body': {
      padding: 0,
      margin: 0,
      height: '100%'
    }
  },
  '@font-face': [
    {
      fontFamily: 'Read',
      fontWeight: '500',
      fontStyle: 'normal',
      src: `url(${readRegularWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readRegularEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'Read',
      fontWeight: '400',
      fontStyle: 'normal',
      src: `url(${readLightWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readLightEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'Read',
      fontWeight: '700',
      fontStyle: 'normal',
      src: `url(${readBoldWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readBoldEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'DaciaSpirit',
      fontWeight: '500',
      fontStyle: 'normal',
      src: `url(${daciaSpiritRegularWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${daciaSpiritRegularEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'DaciaSpirit',
      fontWeight: '400',
      fontStyle: 'normal',
      src: `url(${daciaSpiritLightWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${daciaSpiritLightEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'DaciaSpirit',
      fontWeight: '700',
      fontStyle: 'normal',
      src: `url(${daciaSpiritBoldWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${daciaSpiritBoldEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'DaciaNewSpirit',
      fontWeight: '400',
      fontStyle: 'normal',
      src: `url(${daciaSpiritNewWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${daciaSpiritNewEot}) format("eot")`}
      ]
    },

    // Dacia-Block-Variable
    {
      fontFamily: 'daciaSpirit',
      fontWeight: '700',
      fontStyle: 'normal',
      src: `url(${daciaBlockVariableWoff}) format("woff")`
      // fallbacks: [
      //   {src: `url(${daciaBlockVariableWoff}) format("eot")`}
      // ]
    },

    // readBeta2
    {
      fontFamily: 'readBeta2',
      fontWeight: '400',
      fontStyle: 'normal',
      src: `url(${readBeta2LightWoff}) format("woff2")`
      // fallbacks: [
      //   {src: `url(${readBeta2LightWoff}) format("eot")`}
      // ]
    },
    {
      fontFamily: 'readBeta2',
      fontWeight: '500',
      fontStyle: 'normal',
      src: `url(${readBeta2RegularWoff}) format("woff2")`
      // fallbacks: [
      //   {src: `url(${readBeta2RegularWoff}) format("eot")`}
      // ]
    }
  ]
});

export default globalStyles;



// WEBPACK FOOTER //
// ./src/styles/global.jss.js